<template>
  <div @click="handleProjectJump">
    <slot></slot>
  </div>
</template>

<script>
  import { projectJump } from '@/utils';

  export default {
    name: 'ProjectLink',
    props: {
      to: {
        type: Object,
        require: true,
      },
    },
    methods: {
      handleProjectJump() {
        projectJump(this.to);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
